<template>
  <div class="login flex-center flex-column">
    <img
      v-for="(item, index) in icons"
      :key="index"
      :src="item.url"
      class="icon-item"
      :style="item.style"
    />
    <div class="title">账号注册</div>
    <div class="desc mt-20">趣增长，专业打造私域智慧新零售</div>
    <div class="mt-30">
      <div class="tip">公司</div>
      <Input
        size="large"
        v-model.trim="company"
        prefix="md-briefcase"
        placeholder="请输入公司"
        class="mt-10"
        style="width: 380px"
      />
      <div class="tip mt-15">联系人</div>
      <Input
        size="large"
        v-model.trim="username"
        prefix="ios-person"
        placeholder="请输入联系人"
        class="mt-10"
        style="width: 380px"
      />
      <div class="tip mt-15">手机号</div>
      <Input
        size="large"
        v-model.trim="mobile"
        prefix="md-phone-portrait"
        placeholder="请输入手机号"
        class="mt-10"
        style="width: 380px"
      />
      <div class="tip mt-15">验证码</div>
      <div class="mt-10 flex-row">
        <Input
          size="large"
          v-model.trim="code"
          prefix="md-mail"
          placeholder="请输入验证码"
          style="width: 250px"
        />
        <Button
          class="code-btn flex-center ml-10"
          @click="getCaptcha"
          :loading="captchaLoading"
        >
          <template v-if="status === 1">获取验证码</template>
          <template v-if="status === 2">{{ leftSecond }}s</template>
          <template v-if="status === 3">重新获取</template>
        </Button>
      </div>
    </div>
    <Button
      class="login-btn mt-30 flex-center"
      @click="login"
      :loading="loginLoading"
    >
      开启趣味增长
    </Button>
    <div class="btn-desc mt-20">
      已有账号？<span class="underline" @click="toLogin">立即登录</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { appApi } from "@/api";
export default {
  data() {
    return {
      icons: [
        {
          style: "width: 316px; top: 47px; left: 128px",
        },
        {
          style: "width: 90px; top: 51px; right: 429px",
        },
        {
          style: "width: 423px; right: 60px; bottom: 128px",
        },
        {
          style: "width: 201px; bottom: 113px; left: 80px",
        },
      ],
      company: "",
      username: "",
      mobile: "",
      code: "",
      captchaLoading: false,
      loginLoading: false,
      status: 1, //获取验证码按钮状态 1-初始，2-倒计时，3-重新获取
      leftSecond: 0,
    };
  },

  created() {
    this.icons = this.icons.map((item, index) => {
      item.url = require(`../../assets/login/p${index + 1}.png`);
      return item;
    });
  },

  mounted() {
    this.checkCountdown();
  },

  methods: {
    ...mapActions(["handleRegister", "getUserInfo"]),
    // 获取验证码倒计时处理
    checkCountdown() {
      let lastTime = localStorage.getItem("lastGet");
      if (lastTime) {
        this.calcCountdown(lastTime);
      }
    },

    calcCountdown(time) {
      let now = new Date().getTime();
      let differ = Number(((now - time) / 1000).toFixed(0));
      if (differ < 60) {
        this.status = 2;
        this.leftSecond = parseInt(60 - differ);
        this.timer = setInterval(() => {
          this.leftSecond--;
          if (this.leftSecond === 0) {
            this.status = 3;
            clearInterval(this.timer);
          }
        }, 1000);
      }
    },
    // 登录
    login() {
      let { company, username, mobile, code } = this;
      if (!company) {
        this.$Message.warning("请输入公司名称");
        return;
      }
      if (!username) {
        this.$Message.warning("请输入联系人姓名");
        return;
      }
      if (!this.validateMobile(mobile)) return;
      if (!code) {
        this.$Message.warning("请输入验证码");
        return;
      }
      let p = {
        company,
        username,
        mobile,
        code,
      };
      this.loginLoading = true;
      this.handleRegister(p).then((res) => {
        if (res.code === 0) {
          this.getUserInfo().then(() => {
            this.loginLoading = false;
            this.$router.push({
              path: "/home",
            });
          });
        } else {
          this.loginLoading = false;
          // this.$Message.error(res.errorMsg);
        }
      });
    },
    // 获取验证码
    getCaptcha() {
      let { mobile } = this;
      if (!this.validateMobile(mobile)) return;
      let p = {
        mobile,
      };
      this.captchaLoading = true;
      appApi.getCaptcha(p).then((res) => {
        this.captchaLoading = false;
        if (res.code === 0) {
          let lastGet = new Date().getTime();
          localStorage.setItem("lastGet", lastGet);
          this.checkCountdown();
        } else {
          // this.$Message.error(res.errorMsg);
        }
      });
    },
    // 手机号格式验证
    validateMobile(mobile) {
      let flag = true;
      try {
        if (!mobile) throw Error("请输入手机号");
        let reg2 =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg2.test(mobile)) throw Error("手机号码格式错误");
      } catch (e) {
        this.$Message.warning(e.message);
        flag = false;
      }
      return flag;
    },

    toLogin() {
      this.$router.push({
        path: "login",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 100px;
  z-index: 10;

  .icon-item {
    position: absolute;
    z-index: -1;
  }

  .title {
    height: 40px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 50px;
  }

  .desc {
    height: 25px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
  }

  .tip {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 29px;
  }

  .code-btn {
    width: 122px;
    height: 40px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .login-btn {
    width: 382px;
    height: 40px;
    background: linear-gradient(153deg, #965dea 0%, #623ea5 100%);
    border-radius: 5px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 29px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .btn-desc {
    // width: 240px;
    height: 27px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 26px;
  }
}
</style>